import React from 'react';
import { RESET } from 'jotai/utils';
import { useCallbackOne as useStableCallback } from 'use-memo-one';
import { useAtomEffect } from '../../hooks/useAtomEffect';
import { drawerAtom } from '../atoms/drawer.atom';
import { SIDE_PANEL_ACTIONS } from '../const';
import { useSidePanel } from '../side-panel-provider';
import { useDispatch } from './use-dispatch';
export const useEditAnnotationDrawer = () => {
  const {
    editAnnotationComponent,
    showAnnotationDetailsAtom,
    annotationsAtom,
    selectedAnnotationIdsAtom
  } = useSidePanel();
  const dispatch = useDispatch();
  useAtomEffect(useStableCallback((get, set) => {
    const showAnnotationDetails = get(showAnnotationDetailsAtom);
    const selectedAnnotationIds = get(selectedAnnotationIdsAtom);
    const editAnnotationEnd = () => {
      set(drawerAtom, RESET);
      dispatch({
        type: SIDE_PANEL_ACTIONS.EDIT_ANNOTATION_END
      });
    };
    if (showAnnotationDetails && selectedAnnotationIds.length > 0 && editAnnotationComponent) {
      const selectedId = selectedAnnotationIds[0];
      const annotations = get(annotationsAtom);
      const selectedAnnotationDetails = annotations.find(annotation => annotation.id === selectedId);
      if (!selectedAnnotationDetails) {
        return;
      }
      const annotationName = `${selectedAnnotationDetails.annotationLabel.title.charAt(0).toUpperCase() + selectedAnnotationDetails.annotationLabel.title.slice(1)}\u00A0\u00A0[${selectedAnnotationDetails.id}]`; // \u00A0 is a non-breaking space

      set(drawerAtom, {
        title: () => annotationName,
        description: 'Edit object properties',
        onClose: editAnnotationEnd,
        component: ({
          onClose
        }) => {
          return <React.Fragment key={selectedId}>
                {editAnnotationComponent?.({
              onClose
            })}
              </React.Fragment>;
        },
        isOpen: showAnnotationDetails
      });
    }
  }, []));
};